import { useEffect, useState } from 'react';
import {  Link } from 'react-router-dom'
import axios from 'axios'
import { useNavigate } from 'react-router'

export const DisplayStatusComponent = ({ checkStatus, errorMessageCheckStatus, calculKey }) => {

    const navigate = useNavigate();

    const [resultStatus, setResultStatut] = useState();
    const [exists, setExists] = useState(true);

    useEffect(() => {

        axios.get('/api/aoreadondemand/status?key=' + calculKey).then(response => {
            if (response.data) {
                setResultStatut(response.data)
            }
            else {
                setExists(false);
            }
        })
    }, []);


    // n'existe plus dans le cache
    if (!exists) {
        navigate("/aos/readmatch")
    }

    if (!resultStatus) {
        return <></>
    }


    if (resultStatus.hasThrown) {
        return <div className="alert alert-danger">Le calcul n'a pas pu avoir lieu à cause d'une erreur interne , message = {resultStatus.errorMessage}</div>
    }


    var resultCheckStatus = <></>
    if (!checkStatus(resultStatus)) {
        resultCheckStatus = <div className="alert alert-danger">{errorMessageCheckStatus}, raison = {resultStatus.errorMessage}</div>
    }

    return <><div className="alert alert-primary d-flex flex-row gap-5">
        {(resultStatus.isParsed ? <Link to={"/aos/readmatch/detail/" + calculKey}>détail</Link> : <></>)}
        {(resultStatus.isParsed ? <Link to={"/aos/readmatch/html/" + calculKey}>html de l'appel d'offre</Link> : <></>)}
        {(resultStatus.isCalculated) ? <Link to={"/aos/readmatch/result/" + calculKey}>résultat du calcul</Link> : <></>}
    </div>
        {resultCheckStatus}
    </>
}





